export default "__VITE_ASSET__DIu3X87Q__"